export default __webpack_public_path__ + "static/media/reputation.16f3fbfa.svg";